<template>

  <div class="pages-index">
    <div class="carousel-banner">
      <swiper :options="swiperOptionBanner">
        <swiper-slide class="item1">
          <img style="height:580px" class="banner-img" :src="require('@/assets/yyimages/sy-1.png')" />
          <div class="details-box" data-wow-duration="1.2s" data-wow-delay="0.1s">
          </div>
        </swiper-slide>

        <swiper-slide class="item1">
          <img style="height:580px" class="banner-img" :src="require('@/assets/yyimages/sy-3.png')" />
          <div class="details-box" data-wow-duration="1.2s" data-wow-delay="0.1s">
          </div>
        </swiper-slide>
        <swiper-slide class="item3">
          <img style="height:580px" class="banner-img" :src="require('@/assets/yyimages/sy-4.png')" />
          <div class="details-box wow zoomIn">
          </div>
        </swiper-slide>
        <swiper-slide class="item2">
           <img style="height:580px" class="banner-img" :src="require('@/assets/yyimages/sy-5.png')" />
          <div class="details-box">
          </div>
        </swiper-slide>
        <!-- <swiper-slide class="item4">
          <img style="height:580px" class="banner-img" :src="require('@/assets/yyimages/sy-1.png')" />
          <div class="details-box">
          </div>
        </swiper-slide> -->
        
        <div class="swiper-pagination swiper-banner-pagination"  slot="pagination"></div>
        <div class="swiper-button-prev swiper-banner-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next swiper-banner-button-next" slot="button-next"></div>
      </swiper>     
    </div>

    <div class="bgbox-white">
      <div class="module-title fc-blue">
        株洲市芦淞区中医骨伤专科医院
      </div>
      <div class="product-box" style="padding-top:50px;box-sizing:border-box;">
        <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:10}" :lg="{span:8}">
              <div class="item-img wow slideInLeft">
                <img :src="require('@/assets/yyimages/yyindex-1.png')" />
              </div>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:14}" :lg="{span:16}">
              <router-link to="/main/SDWAN">
                <div class="conts wow slideInRight">
                  <div class="title">
                    <h3>省级非遗"北张正骨术"</h3>
                    <h4><span class="fc-blue">北张正骨术</span>源自<span class="fc-blue">宫廷正骨</span>，迄今已传承近<span class="fc-blue">300年</span>，形成了<span class="fc-blue">正骨、理筋、用药</span>三个完善的正骨治疗体系，是医院的核心特色</h4>
                  </div>
                  
                  <p class="article">株洲市芦淞区中医骨伤专科医院是以省级非遗"北张正骨术"为主要特色的<span class="fc-blue">集临床医疗、教学和科研为一体的公立二级中医骨伤专科医院</span>。</p>
                </div>
              </router-link>
            </el-col>
          </el-row>
        </el-col>
      </div>
    </div>
    <div class="bgbox-gray">
      <div class="product-box">
        <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:14}" :lg="{span:14}">
              <router-link to="/main/routeDev">
                <div class="conts wow slideInLeft">
                  <div class="title">
                    <h3>医院简况</h3>
                   <h4></h4>
                  </div>
                  <p class="article">当前医院建筑面积<span class="fc-blue">4800多</span>平方米，开放床位<span class="fc-blue">120</span>张，临床科室有<span class="fc-blue">正骨科、创伤科、筋伤科、综合内科、治未病科、门急诊</span>6个临床科室。医技科室设有<span class="fc-blue">药剂科、检验科、手术室、放射科、超声科、心电图室</span>
                  等6个科室。拥有<span class="fc-blue">西门子32排螺旋式CT、全数字化DRX光机、1.0千伏C型臂、全身麻醉机、多功能三维电脑微控牵引床、彩超、全自动生化仪</span>等大中型设备。</p>

                </div>
              </router-link>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:10}" :lg="{span:10}">
              <div class="item-img wow slideInRight">
                <img :src="require('@/assets/yyimages/yyindex-2.png')" />
              </div>  
            </el-col>
          </el-row>
        </el-col>
      </div>
    </div>
    <div class="bgbox-white">
      <div class="product-box">
        <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:10}" :lg="{span:10}">
              <div class="item-img wow slideInLeft">
                <img :src="require('@/assets/yyimages/yyindex-3.png')" />
              </div>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:14}" :lg="{span:14}">
              <router-link to="/main/smartTV">
                <div class="conts wow slideInRight">
                  <div class="title">
                    <h3>医院理念</h3>
                    <h4>医院始终坚持<span class="fc-blue">"中医为本、病人为先、弘扬特色、追求卓越"</span>的办院宗旨。</h4>
                  </div>
                  <p class="article">拥有一批<span class="fc-blue">高素质、高学历人才</span>，有完整的<span class="fc-blue">北张正骨传承团队</span>，有<span class="fc-blue">省级非遗传承性项目代表人</span>，骨伤科为<span class="fc-blue">湖南省中医重点专科</span>。</p>

                </div>
              </router-link>
            </el-col>
          </el-row>
        </el-col>
      </div>
    </div>
    <div class="bgbox-gray">
      <div class="product-box">
        <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
          <el-row class="flex-row" type="flex" justify="center">
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:14}" :lg="{span:14}">
              <router-link to="/main/logAudit">
                <div class="conts wow slideInLeft">
                  <div class="title">
                    <h3>张进劳模工作室</h3>
                    <h4>成立于2020年5月，现有成员5人。领衔人<span class="fc-blue">张进</span>是<span class="fc-blue">省级劳动模范</span>、<span class="fc-blue">湖南省非物质文化遗产北张正骨创始人张光靖的第七代嫡系子孙、北张正骨第七代核心传承人</span></h4>
                  </div>
                  <p class="article">张进劳模创新工作室除在本院做好诊疗服务外，还积极开展<span class="fc-blue">巡诊巡讲活动，进乡村、进企业做义诊、科普宣传活动，积极加强与其他医院的交流学习，</span>现在“北张正骨术”在株洲市芦淞区中医骨伤科医院广泛运用于临床，<span class="fc-blue">为广大人民群众提供安全有效的医疗服务</span>。</p>
                </div>
              </router-link>
            </el-col>
            <el-col class="flex-col" :xs="{span:24}" :sm="{span:24}" :md="{span:10}" :lg="{span:10}">
              <div class="item-img wow slideInRight">
                <img :src="require('@/assets/yyimages/yyindex-4.png')" />
              </div>
            </el-col>
          </el-row>
        </el-col>
      </div>
    </div>

    <div class="bgbox-gray bgbox-img">
      <div class="module-title fc-white">
        医院掠影
      </div>
      <div class="project-box project-iptv">
        <el-col :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
          <el-row :gutter="12">
            <el-col :xs="{span:24}" :sm="{span:8}">
              <div class="project-iptv-item wow slideInUp" data-wow-duration="1s" data-wow-delay="0.1s">
                <img :src="require('@/assets/yyimages/yyindex-5.png')" />
                <p></p>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:8}">
              <div class="project-iptv-item wow slideInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                <img :src="require('@/assets/yyimages/yyindex-6.png')" />
                <p></p>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:8}">
              <div class="project-iptv-item wow slideInUp" data-wow-duration="1s" data-wow-delay="0.3s">
                <img :src="require('@/assets/yyimages/yyindex-10.png')" />
                <p></p>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
          <el-row :gutter="12">
            <el-col :xs="{span:24}" :sm="{span:8}">
              <div class="project-iptv-item wow slideInUp" data-wow-duration="1s" data-wow-delay="0.4s">
                <img :src="require('@/assets/yyimages/yyindex-7.png')" />
                <p></p>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:8}">
              <div class="project-iptv-item wow slideInUp" data-wow-duration="1s" data-wow-delay="0.5s">
                <img :src="require('@/assets/yyimages/yyindex-9.png')" />
                <p></p>
              </div>
            </el-col>
            <el-col :xs="{span:24}" :sm="{span:8}">
              <div class="project-iptv-item wow slideInUp" data-wow-duration="1s" data-wow-delay="0.6s">
                <img :src="require('@/assets/yyimages/yyindex-8.png')" />
                <p></p>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </div>
    </div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:20,offset:2}">
        <div class="module7-conts">
          <div class="module-title">
            <span class="title-cn">医院地址</span>
          </div>
          <div class="map-container">
            <baidu-map 
              class="bm-view" 
              :center="center" 
              :zoom="zoom" 
              :scroll-wheel-zoom="true"
              ak="2864FMW4Ct3sCOoin07oxvK8XFPaAPTm"
              @ready="maphandler"
              @moveend="updateMap"
              @zoomend="updateMap">
              <bm-marker :position="center" :dragging="false">
                <bm-info-window :show="showInfoWindow">株洲市芦淞区中医骨伤专科医院</bm-info-window>
              </bm-marker>
              <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
              <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
              <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-map-type>
            </baidu-map>
          </div>
        </div>
      </el-col>
    </div>
    <el-dialog :visible.sync="showBigImg" :center="true" :show-close="false" custom-class="dialog-bigimg">
      <img :src="bigImgSrc" />
    </el-dialog>
  </div>
</template>

<script>
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import BaiduMap from 'vue-baidu-map/components/map/Map.vue'
  import BmMarker from 'vue-baidu-map/components/overlays/Marker'
  import BmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow'
  import BmNavigation from 'vue-baidu-map/components/controls/Navigation'
  import BmScale from 'vue-baidu-map/components/controls/Scale'
  import BmMapType from 'vue-baidu-map/components/controls/MapType'

  export default {
    components: {
      swiper,
      swiperSlide,
      BaiduMap,
      BmMarker,
      BmInfoWindow,
      BmNavigation,
      BmScale,
      BmMapType
    },
    data() {
      let vm = this
      return {
        center: {
          lng: 113.3372840,
          lat: 27.7740579,
        },
        zoom: 16,
        showInfoWindow: true,
        showBigImg: false,
        bigImgSrc:null,
        swiperOptionBanner: {
          autoHeight: true,
          slidesPerView: 1,
          loop: true,
          autoplay:{
            delay: 8000,
            disableOnInteraction: false
          },
          effect: 'fade',
          pagination: {
            el: '.swiper-banner-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-banner-button-next',
            prevEl: '.swiper-banner-button-prev',
          }
        },
        swiperOptionCard: {
          slidesPerView: 4,
          spaceBetween: 10,
          centeredSlides: false,
          loop: false,
          autoplay:false,
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 20,
            }
          },
          pagination: {
            el: '.swiper-card-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-card-button-next',
            prevEl: '.swiper-card-button-prev',
          }
        },
        swiperOptionSdwan: {
          autoHeight: true,
          slidesPerView: 1,
          loop: true,
          autoplay:{
            delay: 5000,
            disableOnInteraction: false
          },
          pagination: {
            el: '.swiper-sdwan-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-sdwan-button-next',
            prevEl: '.swiper-sdwan-button-prev',
          }
        },
        swiperOptionCompany: {
          slidesPerView: 4,
          spaceBetween: 20,
          centeredSlides: true,
          loop: true,
          autoplay:{
            delay: 5000,
            disableOnInteraction: false
          },
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            768: {
              slidesPerView: 4,
              spaceBetween: 30,
            }
          },
          navigation: {
            nextEl: '.swiper-company-button-next',
            prevEl: '.swiper-company-button-prev',
          },
          on:{
            click:function(){
              if(this.clickedSlide){
                vm.bigImgSrc = this.clickedSlide.getElementsByTagName('img')[0].getAttribute('src');
                vm.showBigImg = true;
              }
            }
          }
        },
        swiperOptionPartner: {
          slidesPerView: 6,
          slidesPerColumn: 3,
          spaceBetween: 0,
          centeredSlides: false,
          loop: false,
          autoplay:{
            delay: 1200,
            disableOnInteraction: false
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
              spaceBetween: 0,
            },
            992: {
              slidesPerView: 3,
              spaceBetween: 0,
            }
          },
          pagination: {
            el: '.swiper-partner-pagination',
            clickable: true,
          }
        },
      }
    },
    mounted(){
      // 页面加载完成后强制刷新地图
      setTimeout(() => {
        if (window.BMap) {
          window.dispatchEvent(new Event('resize'));
        }
      }, 1000);
    },
    methods: {
      maphandler({ BMap, map }) {
        console.log('百度地图初始化完成');
        
        // 设置地图中心点和缩放级别
        map.centerAndZoom(new BMap.Point(113.3372840, 27.7740579), 16);
        
        // 启用滚轮缩放
        map.enableScrollWheelZoom(true);
        
        // 启用连续缩放
        map.enableContinuousZoom(true);
        
        // 启用惯性拖动
        map.enableInertialDragging(true);
        
        // 创建标注
        const point = new BMap.Point(113.3372840, 27.7740579);
        const marker = new BMap.Marker(point);
        map.addOverlay(marker);
        
        // 信息窗口
        const infoWindow = new BMap.InfoWindow("株洲市芦淞区中医骨伤专科医院");
        marker.addEventListener("click", function(){
          map.openInfoWindow(infoWindow, point);
        });
        
        // 强制重绘地图，解决显示不全问题
        setTimeout(() => {
          map.checkResize();
        }, 100);
      },
      
      updateMap({ target: map }) {
        // 地图移动或缩放后的回调
        const center = map.getCenter();
        this.center.lng = center.lng;
        this.center.lat = center.lat;
        this.zoom = map.getZoom();
      }
    }
  };
</script>

<style lang="scss">
.module7-conts{
  width: 100%;
  
  .map-container{
    width: 100%;
    height: 500px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    
    .bm-view {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
}

// 响应式调整
@media screen and (max-width: 767px){
  .module7-conts{
    .map-container{
      height: 300px;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1024px){
  .module7-conts{
    .map-container{
      height: 400px;
    }
  }
}

// banner swiper
.carousel-banner {
  .swiper-pagination{
    display: flex;
    align-items: center;
    position: absolute;
    width: auto;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 11px;
    padding: 6px 16px;
  }
  .swiper-pagination-bullet{
    width: 6px !important;
    height: 6px !important;
    background: #fff !important;
    opacity: .8;
  }
  .swiper-pagination-bullet-active{
    background: transparent !important;
    border: 2px solid #fff !important;
  }
}
.partner-box{
  .swiper-container{
    width: 100%;
  }
  .swiper-wrapper{
    padding-bottom: 20px;
  }
  .swiper-pagination{
    bottom: 0;
  }
  .swiper-pagination-bullet{
    width: 18px !important;
    border-radius: 0;
  }
}
// big img
.dialog-bigimg{
  box-shadow: none;
  background: transparent;
  margin: 5% auto 0 !important;
  width: fit-content !important;
  height: auto !important;
  overflow: hidden;
  .el-dialog__header{
    display: none;
  }
  .el-dialog__body{
    padding: 0;
    width: fit-content !important;
    height: auto !important;
    img{
      max-width: 100%;
      max-height: 100%;
      margin: 0 auto;
      display: block;
    }
  }
}
</style>

<style lang="scss" scoped>
.carousel-banner {
  width: 100%;
  position: relative;
  .swiper-container {
    height: 100%;
    width: 100%;
  }
  .swiper-slide .banner-img{
    width: 100%;
  }
  .swiper-button-prev,.swiper-button-next{
    outline: none;
    height: 30px;
  }
  .item1 .details-box{
    width: 30%;
    position: absolute;
    right: 18%;
    top: 10%;
    img{
      width: 100%;
      max-width: 570px;
    }
    .btn{
      margin-top: 30px;
      float: right;
    }
  }
  .item2{
    .details-box{
      width: 30%;
      max-width: 510px;
      position: absolute;
      right: 18%;
      top: 28%;
      img{
        width: 100%;
        max-width: 510px;
      }
      .btn{
        margin-top: 10px;
      }
    }
  }
  .item3{
    .details-box{
      width: 30%;
      max-width: 515px;
      position: absolute;
      left: 18%;
      top: 28%;
      img{
        width: 100%;
      }
      .btn{
        margin-top: 10px;
      }
    }
  }
  .item4{
    .details-box{
      width: 30%;
      max-width: 676px;
      position: absolute;
      left: 18%;
      top: 28%;
      text-align: center;
      img{
        width: 100%;
      }
      .btn{
        margin-top: 10px;
      }
    }
  }
}
@media screen and (max-width: 767px){
  .carousel-banner {
    .banner-img{
      height: 270px;
      object-fit: cover;
    }
    .item1 .details-box{
      width: 38%;
      position: absolute;
      right: 10%;
      top: 10%;
      img{
        width: 100%;
      }
      .btn{
        margin-top: 10px;
        float: right;
      }
    }
    .item2{
      .banner-img{
        object-position: left;
      }
      .details-box{
        width: 260px;
        position: absolute;
        right: 16%;
        top: 12%;
        padding: 10px;
        box-sizing: border-box;
        background: rgba($color: #000000, $alpha: 0.7);
        border-radius: 6px;
        img{
          width: 100%;
        }
        .btn{
          margin-top: 10px;
        }
      }
    }
    .item3{
      .banner-img{
        object-position: right;
      }
      .details-box{
        width: 260px;
        position: absolute;
        left: 12%;
        top: 12%;
        padding: 10px;
        box-sizing: border-box;
        background: rgba($color: #000000, $alpha: 0.7);
        border-radius: 6px;
      }
    }
    .item4{
      background: #977144;
      .banner-img{
        opacity: 0;
      }
      .details-box{
        width: 300px;
        position: absolute;
        left: 50%;
        top: 12%;
        padding: 10px;
        box-sizing: border-box;
        transform: translateX(-50%);
      }
    }
  }
}

.flex-col{
  display: flex;
  align-items: center;
}
.bgbox-white{
  padding: 50px 0;
  overflow: hidden;
  background: #fff;
}
.bgbox-gray{
  padding: 50px 0;
  overflow: hidden;
  background: #f7f7f7;
}
.module-title{
  text-align: center;
  font-size: 26px;
  font-weight: bold;
  line-height: 1;
  padding-bottom: 14px;
  position: relative;
}
.fc-blue{
  color: #0066cc;
}
.module-title.fc-blue::after{
  content: "";
  width: 80px;
  height: 4px;
  background: #0066cc;
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -40px;
  border-radius: 5px;
}
.fc-white{
  color: #fff;
}
.module-title.fc-white::after{
  content: "";
  width: 80px;
  height: 4px;
  background: #fff;
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -40px;
  border-radius: 5px;
}

.card-show{
  overflow: hidden;
  .item{
    float: left;
    width: 100%;
    margin-right: 12px;
    margin-bottom: 10px;
    background: #fff;
    padding: 20px 10px;
    box-sizing: border-box;
    transition: all 0.3s ease;
    h3{
      font-size: 20px;
      color: #333;
      padding-bottom: 5px;
    }
    h4{
      height: 30px;
      font-size: 13px;
      color: #333;
      font-weight: 400;
      margin-bottom: 20px;
    }
    p{
      height: 60px;
      font-size: 14px;
      color: #666;
      margin: 20px 0;
    }
    .img-box{
      width: 100%;
      height: 170px;
      overflow: hidden;
      img{
        min-height:100%;
        width:100%;
        object-fit: cover;
        transition: all 0.3s ease;
      }
    }
  }
  .item:hover{
    cursor: pointer;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    transform: translate3d(0,-2px,0);
    img{
      transform: scale(1.1);
    }
    .el-button{
      color: #409EFF;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
  }
  .item:last-child{
    margin-right:0; 
  }
  .swiper-button-prev,.swiper-button-next{
    outline: none;
    height: 30px;
  }
}

.product-box{
  padding: 10px;
  box-sizing: border-box;
  overflow: hidden;
}
.product-box img{
  width: 100%;
}
.product-box .item-img{
  padding: 0 20px;
  box-sizing: border-box;
}
.product-box .conts{
  cursor: pointer;
  padding: 10px;
  transition: all .3s ease-in;
  &:hover{
    transform: translate3d(0,-6px,0);
  }
}
.product-box .conts h3{
  font-size: 20px;
  color: #333;
  padding-bottom: 5px;
}
.product-box .conts h4{
  font-size: 13px;
  color: #333;
  font-weight: 400;
  margin-bottom: 50px;
}
.product-box .conts .article{
  font-size: 16px;
  color: #333;
}
.stress-box{
  padding-top: 30px;
  box-sizing: border-box;
}
.stress-box h5{
  font-size: 16px;
  color: #333;
  margin-bottom: 30px;
}
.stress-box .stress-items{
  overflow: hidden;
}
.stress-box .stress-items .item{
  float: left;
  width: 80px;
  height: 80px;
  border: 1px solid #d9d9d9;
  box-sizing: border-box;
  text-align: center;
  padding-top: 12px;
  margin-right: 10px;
  margin-bottom: 10px;
}
.stress-box .stress-items .item:last-child{
  margin-right: 0;
}
.stress-box .stress-items .item p{
  font-size: 14px;
  color: #808080;
}

.project-box{
  overflow: hidden;
  width: 100%;
  padding: 40px 10px 0;
  box-sizing: border-box;
}
.project-sdwan{
  .swiper-container {
    width: 100%;
  }
  .swiper-slide img{
    width: 100%;
  }
  .swiper-button-prev,.swiper-button-next{
    outline: none;
    height: 30px;
  }
}

.bgbox-img{
  background: url("../../assets/images/index-project-bg.jpg") no-repeat;
  background-size: 100% 100%;
}
.project-iptv-item {
  margin-bottom: 20px;
}
.project-iptv-item img{
  cursor: pointer;
  vertical-align: middle;
  width: 100%;
  transition: all 0.5s ease;
}
.project-iptv-item p{
  font-size: 20px;
  color: #fff;
  text-align: center;
  line-height: 30px;
}

.company-certify{
  height: auto;
  .swiper-container {
    width: 100%;
    height: 100%;
    &::before{
      content:"";
      width: 12%;
      height: 100%;
      background: linear-gradient(to left, rgba(255,255,255,0) , rgba(255,255,255,1));
      position: absolute;
      left: 0;
      top: 0;
      z-index: 9;
    }
    &::after{
      content:"";
      width: 12%;
      height: 100%;
      background: linear-gradient(to right, rgba(255,255,255,0) , rgba(255,255,255,1));
      position: absolute;
      right: 0;
      top: 0;
      z-index: 9;
    }
  }
  .swiper-slide{
    height: 100%;
    text-align: center;
  }
  .swiper-slide img{
    max-width: 100%;
    max-height: 400px;
    border: 1px solid #eee;
    box-sizing: border-box;
    cursor: pointer;
  }
  .swiper-button-prev,.swiper-button-next{
    outline: none;
    height: 30px;
  }
}

.partner-box{
  overflow: hidden;
  width: 100%;
  padding: 40px 10px 0;
  box-sizing: border-box;
  .img-box{
    padding: 5px;
    box-sizing: border-box;
    img{
      width: 100%;
      vertical-align: middle;
      border: 1px solid #eee;
      box-sizing: border-box;
      transition: all 0.5s ease;
      &:hover{
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
      }
    }
  }
}

// 移动端css
@media screen and (max-width: 767px){
  .product-box .conts{
    padding: 0;
    &:hover{
      background-size: 0;
      box-shadow: none;
    }
  }
  .product-box .conts h4{
    margin-bottom: 20px;
  }
}

// 991
@media screen and (max-width: 991px) {
  .flex-row{
    display: block;
  }
}
</style>